import React from 'react'

const Action = (props) => {
  return (
    <button {...props} className='action-button'>
        <span />
        <span />
        <span />
    </button>
  )
}

export default Action